import { createContext, useContext, useState, useEffect } from 'react'

const ScreenContext = createContext(undefined)

export function ScreenProvider({ children }) {
  const [screen, setScreen] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
    isSmallScreen: window.innerWidth <= 768,
    isMediumScreen: window.innerWidth <= 1200
  })

  useEffect(() => {
    const handleResize = () => {
      setScreen({
        width: window.innerWidth,
        height: window.innerHeight,
        isSmallScreen: window.innerWidth <= 768,
        isMediumScreen: window.innerWidth <= 1200
      })
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <ScreenContext.Provider value={screen}>
      {children}
    </ScreenContext.Provider>
  )
}

export function useScreen() {
  const context = useContext(ScreenContext)
  if (!context) {
    throw new Error('useScreen must be used within a ScreenProvider')
  }
  return context
}
